import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Loader2, AlertCircle } from "lucide-react";

export default function EmailCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get("code");
    const state = params.get("state");
    const providerError = params.get("error");
    // Strip the OAuth params from history immediately (never keep code/state in the URL bar).
    window.history.replaceState({}, document.title, "/settings/email/callback");

    if (providerError) {
      navigate("/profile?tab=connected&error=" + encodeURIComponent("Microsoft authorization was not completed."), { replace: true });
      return;
    }
    if (!code || !state) {
      navigate("/profile?tab=connected&error=" + encodeURIComponent("Missing authorization response from Microsoft."), { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/comm-connection/microsoft/callback", { code, state });
        navigate("/profile?tab=connected&connected=1", { replace: true });
      } catch (e) {
        setError(apiError(e));
        setTimeout(() => navigate("/profile?tab=connected&error=" + encodeURIComponent(apiError(e)), { replace: true }), 1500);
      }
    })();
  }, [params, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="ms-callback">
      <div className="text-center">
        {error ? (
          <>
            <AlertCircle className="w-8 h-8 text-rose-500 mx-auto mb-3" />
            <p className="text-slate-700 font-medium">{error}</p>
            <p className="text-sm text-slate-400 mt-1">Returning to My Profile…</p>
          </>
        ) : (
          <>
            <Loader2 className="w-8 h-8 text-[#006090] mx-auto mb-3 animate-spin" />
            <p className="text-slate-700 font-medium">Connecting your Microsoft account…</p>
          </>
        )}
      </div>
    </div>
  );
}
